import "./styles.css";
import { HighwayGame } from "./game/game";
import { GameUI } from "./ui/game-ui";

const canvas = document.querySelector<HTMLCanvasElement>("#gameCanvas");

if (!canvas) {
  throw new Error("Canvas element #gameCanvas was not found.");
}

const ui = new GameUI({
  hud: "#hud",
  speedValue: "#speedValue",
  scoreValue: "#scoreValue",
  comboValue: "#comboValue",
  livesValue: "#livesValue",
  lanePressure: "#lanePressure",
  menuOverlay: "#menuOverlay",
  pauseOverlay: "#pauseOverlay",
  gameOverOverlay: "#gameOverOverlay",
  finalScore: "#finalScore",
  bestScore: "#bestScore",
  overtakes: "#overtakes",
  nearMisses: "#nearMisses",
  penalties: "#penalties",
  startButton: "#startButton",
  restartButton: "#restartButton",
  muteButton: "#muteButton"
});

const game = new HighwayGame(canvas, ui);

ui.onStart(() => game.start());
ui.onRestart(() => game.restart());
ui.onMuteToggle((muted) => game.setMuted(muted));

game.boot();

declare global {
  interface Window {
    highwayGame?: HighwayGame;
  }
}

window.highwayGame = game;
